import type { OneOffOrderOrigin } from 'reducers/oneOffOrderOrigin'
import { ONE_OFF_ORDER_ORIGIN } from 'reducers/oneOffOrderOrigin'

type StateWithOneOffOrderOrigin = { oneOffOrderOrigin: OneOffOrderOrigin }

export const getOneOffOrderOrigin = ({
  oneOffOrderOrigin,
}: StateWithOneOffOrderOrigin): OneOffOrderOrigin => oneOffOrderOrigin

export const getIsFromEmptyStateDashboard = (state: StateWithOneOffOrderOrigin): boolean =>
  getOneOffOrderOrigin(state) === ONE_OFF_ORDER_ORIGIN.emptyStateDashboard
